import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PhoneMockProps {
  children: ReactNode;
  className?: string;
  /** Optional label shown next to the frame (for dev/debug screenshots). */
  screenClassName?: string;
}

/**
 * iPhone-style device frame. Uses fixed pixel dimensions so the interior
 * mock screens (OpenRunsMock etc.) can rely on a predictable canvas.
 *
 * Frame softens in light mode (mid-grey instead of near-black) so the
 * device doesn't punch a hole through the page. Screen stays dark because
 * the real mobile app is currently dark-only.
 */
export function PhoneMock({
  children,
  className,
  screenClassName,
}: PhoneMockProps) {
  return (
    <div
      className={cn(
        "relative mx-auto h-[580px] w-[280px] rounded-[42px] bg-zinc-900 p-[6px] shadow-2xl ring-1 ring-black/10",
        className
      )}
    >
      {/* Dynamic-island / notch */}
      <div className="absolute left-1/2 top-[14px] z-20 h-[22px] w-[84px] -translate-x-1/2 rounded-full bg-black" />

      {/* Screen */}
      <div
        className={cn(
          "relative h-full w-full overflow-hidden rounded-[36px] bg-[#0d1117] text-[#F5F5DC]",
          screenClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
